export default "__VITE_ASSET__CI7stuwF__"